import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AffiliateProgramService } from 'src/app/api/affiliate-program.service';
import { AffiliateRewardStep } from 'src/app/models/affiliate';

@Component({
  selector: 'affiliate-rewards',
  templateUrl: './affiliate-rewards.component.html',
  styleUrls: ['./affiliate-rewards.component.scss']
})
export class AffiliateRewardsComponent implements OnInit, OnChanges {
  @Input('currency') currency: string;

  data: AffiliateRewardStep[];
  loading = false;
  error: string = null;

  constructor(private affiliateSerivce: AffiliateProgramService) { }
  
  ngOnInit() {

  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.error = null;

    this.affiliateSerivce.getAffiliateSteps(this.currency).subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

}
